import React, { useEffect, useState } from 'react';
import { PaymentElement, useStripe, useElements } from '@stripe/react-stripe-js';
import '../../styles/App.css';
import { AddressElement } from '@stripe/react-stripe-js';
import { RETURN_PATHS, checkoutReturnUrl } from '../../service/checkoutReturn';
export default function CheckoutForm({
  paymentType,
  returnPath = RETURN_PATHS.donation,
  addressMode = 'shipping',
  addressDefaults = null,
  paymentMethodOrder = null,
  intent = 'payment',
}) {
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get('payment_intent_client_secret');

    if (!clientSecret) {
      return;
    }

    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      switch (paymentIntent.status) {
        case 'succeeded':
          setMessage('Payment succeeded!');

          break;
        case 'processing':
          setMessage('Your payment is processing.');
          break;
        case 'requires_payment_method':
          setMessage('Your payment was not successful, please try again.');
          break;
        default:
          setMessage('Something went wrong.');
          break;
      }
    });
  }, [stripe]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js hasn't yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    setIsLoading(true);

    const confirm = intent === 'setup' ? stripe.confirmSetup : stripe.confirmPayment;
    const { error } = await confirm.call(stripe, {
      elements,
      confirmParams: {
        // Make sure to change this to your payment completion page
        // return_url: 'http://localhost:3000/payment-success',

        return_url: checkoutReturnUrl(returnPath),
        // payment_method_data: {
        //   type: 'donation',
        // },
      },
    });

    if (error.type === 'card_error' || error.type === 'validation_error') {
      setMessage(error.message);
    } else {
      setMessage('An unexpected error occurred.');
    }

    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: 'tabs',
    // e.g. ['us_bank_account', 'card'] on the pay-link page: bank transfer
    // first because it costs KBT 0.8% (max $5) instead of 2.9% + 30¢.
    ...(paymentMethodOrder ? { paymentMethodOrder } : {}),
  };

  return (
    <form id="payment-form" className="stripe-elements-form" onSubmit={handleSubmit}>
      <AddressElement
        options={{
          mode: addressMode,
          ...(addressDefaults ? { defaultValues: addressDefaults } : {}),
        }}
      />

      <PaymentElement id="payment-element" options={paymentElementOptions} />
      <button disabled={isLoading || !stripe || !elements} id="submit">
        <span id="button-text">{isLoading ? <div className="spinner" id="spinner"></div> : intent === 'setup' ? 'Save payment method' : 'Pay now'}</span>
      </button>
      {/* Show any error or success messages */}
      {message && <div id="payment-message">{message}</div>}
    </form>
  );
}
